const Heading = ({ text, className = "" }) => {
    return (
        <h1 className={`text-4xl xl:text-5xl xl:leading-[3.5rem] ${className}`}>{text}</h1>
    );
};

export default Heading;